import React, { useState, useEffect } from 'react'
import AudioPlayer from 'react-h5-audio-player'
import { AnswerType } from '../../Show'
import { get } from '~/utils/api'

type Props = {
  item: AnswerType
}

const Player: React.FC<Props> = ({ item }) => {
  const [recordings, setRecordings] = useState([])

  useEffect(() => {
    getRecordings(item)
  }, [])

  const getRecordings = async item => {
    if (item.infolineCall) {
      const response: [] = await get(
        `calls/${item.infolineCall.id}/recording/url`
      )
      setRecordings(response)
    }
  }

  return (
    <>
      {recordings.map((recordingUrl, index) => (
        <AudioPlayer
          key={index}
          src={recordingUrl}
          showJumpControls={false}
          customAdditionalControls={[]}
          onPlayError={e => console.error('Player play error', e)}
          onError={e => console.error('Player error', e)}
        />
      ))}
    </>
  )
}

export default Player
